/**
 * Layout a flex layout to fill the space 
 * slot for toolbars
 * slot for footer
 * 
 */

import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class FlexLayout extends BaseComponent {
	
	static get properties() {
		return {
			contentOverflow: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		this.contentOverflow = true;
	}
	
	render() {	
		return html`
			<style>
				.box {
				  display: flex;
				  flex-flow: column;
				  height: 100%;
				  width: 100%;
				  min-height: 0;
				}

				.box .row {
				 /* border: 1px solid lightgrey; */
				}

				.box .row.header {
				  flex: 0 1 auto;		
				}

				.box .row.content {
				  flex: 1 1 auto;
				  min-height: 0;
				  overflow: ${this.contentOverflow ? 'auto' : 'hidden'};
				}

				.box .row.footer {
				  flex: 0 0 auto;
				  flex-shrink: 0;
				  max-height: 40vh;
				  overflow: auto;
				}

				@media only screen and (max-width: 1024px) {
					.box .row.footer {
						max-height: none;
					}
				}						
			</style>
			<div class="box">
			  <div class="row header">
				<slot name="toolbar"></slot>
			  </div>
			  <div class="row content">
				<slot name="primary"></slot>
			  </div>
			  <div class="row footer">
				<slot name="footer"></slot>
			  </div>
			</div>	
		`;
	}
};
customElements.define('dl-flex-layout', FlexLayout);

